module.exports = __webpack_public_path__ + "fonts/material-icons-two-tone.3baa5b8.woff";